import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

const Index = () => {
  const { register, getValues, setValue, watch } = useFormContext();
  const nazivPolja = useMemo(() => "razlogBrisanja", []);
  const razlogBrisanja = getValues(nazivPolja);
  const watchRazloziBrisanja = watch(nazivPolja);
  const razloziBrisanja = getValues("razloziBrisanja");

  return (
    <FormControl
      fullWidth
      error={!daLiJePoljeValidno(nazivPolja)}
      sx={{ mt: 3 }}
    >
      <InputLabel id={nazivPolja}>Razlog brisanja (Reason for deletion)</InputLabel>
      <Select
        labelId={nazivPolja}
        id={nazivPolja}
        value={razlogBrisanja}
        label={`Razlog brisanja (Reason for deletion)`}
        variant={"standard"}
        {...register(nazivPolja)}
        onChange={(e: SelectChangeEvent<any>) =>
          setValue(nazivPolja, e.target.value)
        }
      >
        {razloziBrisanja.map((razlog: string, key: number) => (
          <MenuItem key={key} value={razlog}>
            {razlog}
          </MenuItem>
        ))}
      </Select>
      <PorukaGreskePolja nazivPolja={nazivPolja} />
    </FormControl>
  );
};

export default Index;
